import React, {useState, useEffect} from 'react';
import { getExpressParams } from '../../../service/api';
import { Channel_CODE_SET } from '../../../config/CgmCodeSet';
import { REPORT_TYPE_SET } from '../../../config/ReportOptionSet';
import JSONtoReportData from '../json-to-chartdata/JSONtoReportData';
import LoadingOverlay from 'react-loading-overlay';
import ReportCreateResult from '../../presentation/section/report-create-page/ReportCreateResult';
import AlertModal from '../../presentation/modal/AlertModal';

const BuzzlistWindow = (props) => {
  const [resultData, setResultData] = useState(null);
  const [loaded, setLoaded] = useState(true);
  const [loadingText, setLoadingText] = useState(<div>loading</div>);

  const options = {
    timeunit: 'daily',
    datatype: 'numeric',
    rows: '50',
    words: '200',
    morph: 'all',
    buzzRows: '10'
  };

  const [alertShow, setAlertShow] = useState(false);
  const handleAlertShow = () => setAlertShow(true);
  const handleAlertClose = () => {
    setAlertShow(false);
    props.closeBuzzlistWindow();
  }

  useEffect(() => {
    setResultData(null);

    setLoaded(false);
    handleLoadingText();

    let retJSON = {
      dateRange: [props.clickedData.date.replace(/\-/g,""), props.clickedData.date.replace(/\-/g,"")],
      sub_query_type: props.subQueryType,
      retwit: props.reTweet == "true",
      reportType: "buzzlist",
      name: "결과_미리보기",
      channel: props.channels,
      query: [props.mainQuery, ...props.subQuery]
    }
    if (props.clickedData.hasOwnProperty('end_date')){
      retJSON.dateRange = [props.clickedData.date.replace(/\-/g,""), props.clickedData.end_date.replace(/\-/g,"")]
    }
    else {
      retJSON.dateRange = [props.clickedData.date.replace(/\-/g,""), props.clickedData.date.replace(/\-/g,"")]
    }

    getExpressParams(`/report/buzzlist/json`, {
      email: 'undefined-user',
      json: retJSON
    }, (response) => {
      if(response.data.success){
        setLoaded(true)
        setLoadingText(<div>loadng</div>)
        setResultData(JSONtoReportData(response.data.report_data, options));
      }
      else{
        setLoaded(true)
        setLoadingText(<div>loadng</div>)
        handleAlertShow();
      }
    })
  },[])

  const handleLoadingText = () => {
    let outputBaseQuery = props.mainQuery.name;
    let outputSubQuery = [];
    props.subQuery.forEach(subQueryItem=>{
      outputSubQuery.push(subQueryItem.name)
    });
    let outputChannel = [];
    props.channels.forEach(channelItem=>{
      outputChannel.push(Channel_CODE_SET[channelItem])
    })

    setLoadingText(
    <span style={{textAlign: "left"}}>
      <div>
        {props.clickedData.hasOwnProperty('end_date') ? 
          `Date: ${props.clickedData.date} ~ ${props.clickedData.end_date}`
          :`Date: ${props.clickedData.date} ~ ${props.clickedData.date}`
        }
      </div>
      <div>
        BaseKeyword: {outputBaseQuery}
      </div>
      {outputSubQuery.length != 0 ?
      <>
        <div>
          SubKeyword: {outputSubQuery.map((item,index)=>{
            if (index==outputSubQuery.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)
          })}
        </div>
        <div>
          SubKeywordType: {props.subQueryType=="compare"? "비교" : "교차"}
        </div>
      </>
      :undefined}
      <div>
        Channel: {outputChannel.map((item,index)=>{
            if (index==outputChannel.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)        
        })}
      </div>
      <div>
        Report Type: {REPORT_TYPE_SET['buzzlist']}
      </div>
    </span>
    )
  }

  return (
    <div className="buzzlist-window">
      <AlertModal alertShow={alertShow} handleAlertClose={handleAlertClose} handleAlertShow={handleAlertShow} />
      <LoadingOverlay
        active={!loaded}
        spinner={true}
        text={loadingText}>
        <ReportCreateResult data={resultData} options={options} userRole={props.userRole} />
      </LoadingOverlay>
    </div>
  )
}

export default BuzzlistWindow;